<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
   <w-form ref="zform" v-model="valid" v-model:errors-count="errorsCount" @submit.prevent="validateForm" @success="success">
    
    <z-page :title="title">
    <div class="w-card__content content-hardcode">
        <div class="w-flex wrap smd-column" >
           <div class="grow " >
           <z-select class="mt4" outline :items="premis" label="ID / Nama Premis *"  v-model="form.premis_id" @input="getTernakan(form, 2)" :validators="[validators.required]"/>
           <br>
           <div class="w-flex wrap smd-column" >
          <div class="grow " >
          <div style="margin:5px;" class="fw-normal my1 fs-1"><b> Pasung : </b><w-radios
                class="mr2"
                v-model="form.pasung"
                :items="pasung_list"
                inline
                color="blue-light1">
              </w-radios></div>
          </div>
        </div>
           </div>
           <div class="mx2"></div>
           <div class="grow " >
           <br>
           <template v-if="form.lkp_negeri_id">
            <div style="margin:17px;" class="fw-normal my1 fs-1"><b>Negeri : </b>{{form.lkp_negeri}}</div>
         </template>
         </div>
       </div>
       <br>
       
       <div class="notice-container">
            <div class="notice-icon">
              <w-icon class="notice-icon-symbol">fal fa-exclamation-triangle</w-icon>
            </div>
            <div class="notice-content">
              <h3 class="notice-title">Penting</h3>
              <p class="notice-message">Sila hubungi Jurusuntik/Juruteknik yang dipilih sebelum menghantar permohonan</p>
            </div>
          </div>
       </div>
    <br>
    <div class="w-card__content content-hardcode">
    <div class="w-flex wrap smd-column" >
      <div class="grow " >
        <z-select class="mt4" outline :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form.lkp_ternakan_id" @input="getTernakan(form);getJuruteknik(form);getBakaTernakan(form.lkp_ternakan_id)"  :validators="[validators.required]"/>
        <z-select class="mt4" outline :items="lkp_negeri" label="Negeri Juruteknik *"  v-model="form.lkp_negeri_id" @input="getJuruteknik(form)"  :validators="[validators.required]"/>
        
        <w-select 
            class="mt4" 
            outline 
            label="Nama Juruteknik/Jurusuntik *" 
            :items="juruteknik_list" 
            v-model="form.juruteknik_id" 
            :validators="[validators.required]"
            @mousedown.prevent="Jurus(form)"
         />
       </div>
      <div class="mx2"></div>
      <div class="grow " >
           <w-input class="mt4"  label="Tarikh Pengesanan Berahi *" type="date" :max="tarikh_today" v-model="form.tarikh_pengesanan_biang" outline  :validators="[validators.required]"/>  
           <w-input class="mt4"  label="Waktu Pengesanan Berahi *" type="time" v-model="form.masa_pengesanan_biang" outline :validators="[validators.required]" />  
      </div>
    </div>
    <br>
    
    <!-- CARIAN FILTER UNTUK JADUAL UTAMA -->
    <div class="filter-container">
      <div class="filter-wrapper">
        <!-- div class="filter-icon">
          <w-icon>fal fa-filter</w-icon>
          <span class="filter-title">Carian Ternakan</span>
        </div> -->
        <div class="filter-input-group">
          <w-input 
            class="filter-input"
            placeholder="Carian ID Ternakan atau Nama Ternakan..."
            v-model="filter_carian"
            clearable
            @input="filterTernakanList">
            <template #prepend>
              <w-icon>fal fa-search</w-icon>
            </template>
          </w-input>
          <w-button 
            v-if="filter_carian" 
            class="clear-filter-btn ml1" 
            @click="clearFilter"
            outline
            small>
            <w-icon class="mr1">fal fa-times</w-icon> Clear
          </w-button>
        </div>
        <div v-if="filter_carian && ternakan_list_original && ternakan_list_original.length" class="filter-info">
          <span class="badge-filter">
            <w-icon class="mr1">fal fa-search</w-icon> 
            Ditemui: {{ (filtered_ternakan_list || []).length }} daripada {{ (ternakan_list_original || []).length }} rekod
          </span>
        </div>
      </div>
    </div>
    
    <!-- JADUAL UTAMA TERNAKAN -->
    <div class="modern-table-container" style="max-height: 400px; margin-top: 20px;">
      <div class="table-scroll-wrapper">
        <table class="modern-table">
          <thead>
            <tr>
              <th class="table-header text-left" width="1%">BIL</th>
              <th class="table-header text-left">NO. PENDAFTARAN</th>
              <th class="table-header text-left">ID | NAMA TERNAKAN</th>
              <th class="table-header text-left">UMUR (BULAN)</th>
              <th class="table-header text-left">BAKA</th>
              <th class="table-header text-left">JENIS BERAHI</th>
              <th class="table-header text-left">TARIKH SINKRO TERDAHULU</th>
              <th class="table-header text-left">TARIKH AI TERDAHULU</th>
              <th class="table-header text-left">TARIKH BERANAK TERDAHULU</th>
              <th class="table-header text-left">STATUS</th>
              <th class="table-header text-left">JENIS PILIHAN SEMEN</th>
              <th class="table-header text-center"><w-checkbox v-model="checkin" @change="klickPilih()" class="header-checkbox"></w-checkbox></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="!filtered_ternakan_list || filtered_ternakan_list.length == 0">
              <tr class="table-row">
                <td class="table-cell text-center" colspan="12">
                  <div class="no-data">
                    <w-icon class="mr2">fal fa-inbox</w-icon> 
                    <span v-if="filter_carian">Tiada hasil carian untuk "{{ filter_carian }}"</span>
                    <span v-else>Tiada Data.</span>
                  </div>
                </td>
              </tr>
            </template>
            <template v-for="(dt, ind) in filtered_ternakan_list" :key="dt.ternakan_id || ind">
              <tr class="table-row" :class="{ 'row-hover': true, 'highlight-match': isMatchFilter(dt) }">
                <td class="table-cell text-left">{{ind+1}}</td>
                <td class="table-cell text-left">{{dt.kode || '-'}}</td>
                <td class="table-cell text-left" style="text-transform: uppercase;">
                  <span v-html="highlightText((dt.id_ternakan || '') + ' | ' + (dt.nama_ternakan || ''))"></span>
                </td>
                <td class="table-cell text-left">{{$zutil.umurBln(dt.tarikh_lahir) || 0}}</td>
                <td class="table-cell text-left">{{dt.baka || '-'}}</td>
                <td class="table-cell text-left">
                  <template v-if="dt.art == null">
                    <w-select class="modern-select" placeholder="Pilih Satu.." outline :items="lkp_berahi" v-model="dt.lkp_berahi_id" :validators="[validators.required]"/>
                  </template>
                  <template v-else>
                    <template v-if="dt.sudah_pilih == 1">
                      <w-select class="modern-select" placeholder="Pilih Satu.." outline :items="lkp_berahi" v-model="dt.lkp_berahi_id" :validators="[validators.required]"/>
                    </template>
                  </template>
                </td>
                <td class="table-cell text-left">{{$zutil.dateformat(dt.art_ternakan_sinkron ? dt.art_ternakan_sinkron.tarikh_ai : '' )}}</td>
                <td class="table-cell text-left">{{$zutil.dateformat(dt.tarikh_suntik)}}</td>
                <td class="table-cell text-left">{{$zutil.dateformat(dt.tarikh_beranak)}}</td>
                <td class="table-cell text-left">{{dt.art_ternakan ? dt.art_ternakan.lkp_status_nama : ''}} {{dt.art_ternakan ? dt.art_ternakan.lkp_art_kode : ''}}</td>
                <td class="table-cell text-left">
                  <template v-if="dt.art == null">
                    <w-select class="modern-select" placeholder="Pilih Satu.." @input="klickSemen(dt)" outline :items="lkp_baka" v-model="dt.jenis_semen"/>
                  </template>
                  <template v-else>
                    <template v-if="dt.sudah_pilih == 1">
                      <w-select class="modern-select" placeholder="Pilih Satu.." @input="klickSemen(dt)" outline :items="lkp_baka" v-model="dt.jenis_semen"/>
                    </template>
                  </template>
                </td>
                <td class="table-cell text-center">
                  <template v-if="dt.art == null">
                    <w-checkbox v-model="dt.pilih" @input="klickPi(dt)" class="row-checkbox"></w-checkbox>
                  </template>
                  <template v-else>
                    <template v-if="dt.sudah_pilih == 1">
                      <w-checkbox v-model="dt.pilih" @input="klickPi(dt)" class="row-checkbox"></w-checkbox>
                    </template>
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

    <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['1', '2', '5'])">
      <w-button class="my1" :loading="form.submitted && !form.sent" @click="send(2); onSuccess()">
        <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
      </w-button>
      &nbsp;
      <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(1)">
        <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
      </w-button>
    </w-flex>
    <div class="mt2 text-left">
      <w-button style="
        background-color: #f0f0f0; 
        border: 2px solid red; 
        color: #333; 
        padding: 7px 14px; 
        font-size: 10px; 
        font-weight: bold; 
        border-radius: 4px; 
        cursor: pointer;
      " @click="tutup()">TUTUP</w-button>&nbsp;
    </div>
    </div>
  </z-page>
  </w-form>

    <!-- Dialog Carian Juruteknik -->
    <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" width="800" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
      <template #title>CARIAN JURUTEKNIK</template>
      <w-flex justify-center align-center>
        <div class="xs8">
          <w-input label="Nama Juruteknik (Carian minimum 2 aksara)" v-model="carian_juru.q"></w-input>
        </div>
        <div class="xs4">
          <w-button class="ml1" @click="getJuruteknik(form)">Cari</w-button>
        </div>
      </w-flex>
      <br><br>
      <div class="w-table-wrap" style="max-height: 400px;">
        <div class="table-profil-scrol">
          <table class="w-table">
            <thead>
              <tr>
                <th class="w-table__header w-table__header--sortable text-left">No</th>
                <th class="w-table__header w-table__header--sortable text-left">Nama</th>
                <th class="w-table__header w-table__header--sortable text-left">Jenis</th>
                <th class="w-table__header w-table__header--sortable text-left">Pilih</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(dt, index) in juruteknik_list" :key="index">
                <td class="w-table__cell text-left">{{(index+1)}}</td>
                <td class="w-table__cell">{{dt.label}}</td>
                <td class="w-table__cell">{{dt.jenis_pengguna}}</td>
                <td class="w-table__cell text-right">
                  <w-radio class="mr2" v-model="form.juruteknik_id" :return-value="dt.value" @click="dialog.show = false"></w-radio>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #actions>
        <div class="spacer" />
        <w-button style="background-color: #f0f0f0; border: 2px solid red; color: #333; padding: 7px 14px; font-size: 10px; font-weight: bold; border-radius: 4px; cursor: pointer;" @click="dialog.show = false">TUTUP</w-button>
      </template>
    </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'art.permohonan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Permohonan', route: '/art' },
        { label: 'Permanian Beradas (AI)', route: '/art/permohonan' },
      ],
      pasung_list:[
        {value: 1, label: "Ada"},
        {value: 2, label: "Tiada"},
      ],
      negeri : '',
      title : 'ART Permohonan',
      form : this.d_form,
      lkp_negeri : this.d_lkp_negeri,
      ternakan_list: [],
      ternakan_list_original: [],
      filtered_ternakan_list: [],
      filter_carian: '',
      premis : [],
      juruteknik_list : [],
      lkp_ternakan : [],
      lkp_status : [],
      lkp_art : [],
      lkp_tujuan :[],
      lkp_berahi: [],
      loading : 0,
      lkp_baka:[],
      carian_juru : {q: ''},
      checkin:false,
      tarikh_today:'',
      dialog: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 900,
        item: {}
      }
    }
  },
  methods: {
    filterTernakanList() {
      try {
        if (!this.filter_carian || this.filter_carian.trim() === '') {
          this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
          return;
        }
        
        const searchTerm = this.filter_carian.toLowerCase().trim();
        const originalList = this.ternakan_list_original || [];
        
        this.filtered_ternakan_list = originalList.filter(item => {
          if (!item) return false;
          const idTernakan = (item.id_ternakan || '').toLowerCase();
          const namaTernakan = (item.nama_ternakan || '').toLowerCase();
          const kode = (item.kode || '').toLowerCase();
          
          return idTernakan.includes(searchTerm) || 
                 namaTernakan.includes(searchTerm) ||
                 kode.includes(searchTerm);
        });
      } catch (error) {
        console.error('Error filtering:', error);
        this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
      }
    },
    
    isMatchFilter(item) {
      if (!this.filter_carian || !item) return false;
      const searchTerm = this.filter_carian.toLowerCase().trim();
      const idTernakan = (item.id_ternakan || '').toLowerCase();
      const namaTernakan = (item.nama_ternakan || '').toLowerCase();
      
      return idTernakan.includes(searchTerm) || namaTernakan.includes(searchTerm);
    },
    
    highlightText(text) {
      if (!this.filter_carian || !text) return text;
      
      try {
        const searchTerm = this.filter_carian.toLowerCase().trim();
        const textLower = text.toLowerCase();
        
        if (textLower.includes(searchTerm)) {
          const regex = new RegExp(`(${this.escapeRegExp(searchTerm)})`, 'gi');
          return text.replace(regex, '<span class="highlight-text">$1</span>');
        }
        return text;
      } catch (error) {
        return text;
      }
    },
    
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    
    clearFilter() {
      this.filter_carian = '';
      this.filtered_ternakan_list = this.ternakan_list_original ? [...this.ternakan_list_original] : [];
    },
    
    Jurus(form){
      this.dialog.show = true;
      this.form.saveButton = "Simpan"
    },
    
    klickSemen(dt){
      if (dt.jenis_semen == 0) {
        dt.pilih = false;
      } else {
        dt.pilih = true;
      }
      if(dt.pilih == false){
        dt.jenis_semen = 0
      }
    },
    
    klickPi(dt){
      if(dt.pilih == false){
        dt.jenis_semen = 0;
      }
    },
    
    lkpBerahi() {
      this.$zcomm.get(this.api_service + 'lookup/berahi', {}).then(res => {
        this.lkp_berahi = res
      }).catch(err => console.error('Error loading berahi:', err));
    },
    
    validateForm() {
      this.loading=true;
      let isValid = true;
      let jumlah_lulus = 0;
      for (var i in this.ternakan_list) {
        if (this.form.lkp_art_id == 1 && (this.ternakan_list[i].pilih==false && this.ternakan_list[i].jenis_semen!=0 || this.ternakan_list[i].jenis_semen==0 && this.ternakan_list[i].pilih==true || !this.ternakan_list[i].lkp_berahi_id)) {
          isValid = false;
          break;
        }
        if(this.ternakan_list[i].pilih==true && this.ternakan_list[i].jenis_semen!=0){
          jumlah_lulus = 1;
        }
      };
      if(!this.form.premis_id || !this.form.juruteknik_id || !this.form.lkp_ternakan_id || !this.form.tarikh_pengesanan_biang || !this.form.masa_pengesanan_biang){
        isValid = false;
      }
      if(jumlah_lulus == 0 && isValid == true){
        isValid = false;
      }
      if (!isValid) {
        this.$zutil.notify("Pastikan data sudah dipilih", false);
        this.loading=false;
        return false;
      }
      this.onSuccess();
    },
    
    send(hantar){
      this.form.hantar = hantar
    },

    klickPilih(){
      for (var b in this.ternakan_list) {
        if (this.ternakan_list[b].art == null) {
          this.ternakan_list[b].pilih = this.checkin
        }
      }
    },
    
    onSuccess(){
      this.form.ternakan_list = this.ternakan_list;
      if(this.form.hantar == 1){
        this.$swal({
          title: 'Anda Pasti?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            if (this.form.id > 0){
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
              .then(res => {
                if (typeof this.onAfterEdit === "function") this.onAfterEdit()
                if (this.form.hantar==1) this.$inertia.visit(this.$route('art.semakan.index'));
                else this.$zutil.notify("Berjaya disimpan", true);
              })
            } else {
              this.$zcomm.post(this.resourceurl+'.store', this.form)
              .then(res => {
                if (typeof this.onAfterAdd === "function") this.onAfterAdd()
                this.$zutil.notify("Berjaya dihantar", true);
                this.$inertia.visit(window.route('art.semakan.index'));
              })
            }
          }
        })
      } else {
        if (this.form.id > 0) {
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") this.onAfterEdit()
            if (this.form.hantar==1) this.$inertia.visit(this.$route('art.semakan.index'));
            else {
              this.$zutil.notify("Berjaya disimpan", true);
              this.$inertia.visit(this.$route('art.permohonan.ai', this.form.id));
            }
          })
        } else {
          this.$zcomm.post(this.resourceurl+'.store', this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") this.onAfterAdd()
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('art.permohonan.ai', res.id));
          })
        }
      }
    },

    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
        if (this.premis.length == 1) {
          for (var p in this.premis) {
            this.form.premis_id = this.premis[p].value;
            this.form.lkp_negeri_id = this.premis[p].lkp_negeri_id;
            this.form.lkp_negeri = this.premis[p].lkp_negeri;
          }
        }
      }).catch(err => console.error('Error loading premis:', err));
    },

    getData(){
      this.getTernakan(this.d_form, 1);
      this.getJuruteknik(this.d_form);
      this.getBakaTernakan(this.form.lkp_ternakan_id);
    },

    getTernakan(data, item){
      if(item == 2){
        this.form.lkp_ternakan_id = 0;
        this.form.juruteknik_id = 0;
        this.$zcomm.get(this.api_service + 'ternakan/tidak_bunting/'+data.premis_id+'/'+data.lkp_ternakan_id+'/0', {}).then(res => {
          this.ternakan_list_original = res || []
          this.ternakan_list = res || []
          this.filtered_ternakan_list = res || []
          if(data.ternakan_list && data.ternakan_list.length > 0){
            for (var i in this.ternakan_list) {
              for (var t in data.ternakan_list) {
                if(this.ternakan_list[i] && data.ternakan_list[t] && this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                  this.ternakan_list[i].pilih = true;
                  this.ternakan_list[i].sudah_pilih = 1;
                  this.ternakan_list[i].jenis_semen = data.ternakan_list[t].jenis_semen;
                  this.ternakan_list[i].art_ternakan_sinkron = data.ternakan_list[t].art_ternakan_sinkron;
                }
              }
            }
          }
        }).catch(err => console.error('Error loading ternakan:', err));
        this.getJuruteknik(this.d_form);
      } else {
        if(data.premis_id !='' && data.lkp_ternakan_id !=''){
          this.$zcomm.get(this.api_service + 'ternakan/tidak_bunting/'+data.premis_id+'/'+data.lkp_ternakan_id+'/0', {}).then(res => {
            this.ternakan_list_original = res || []
            this.ternakan_list = res || []
            this.filtered_ternakan_list = res || []
            if(data.ternakan_list && data.ternakan_list.length > 0){
              for (var i in this.ternakan_list) {
                for (var t in data.ternakan_list) {
                  if(this.ternakan_list[i] && data.ternakan_list[t] && this.ternakan_list[i].ternakan_id == data.ternakan_list[t].ternakan_id){
                    this.ternakan_list[i].pilih = true;
                    this.ternakan_list[i].sudah_pilih = 1;
                    this.ternakan_list[i].jenis_semen = data.ternakan_list[t].jenis_semen;
                  }
                }
              }
            }
          }).catch(err => console.error('Error loading ternakan:', err));
          this.getJuruteknik(this.d_form);
        }
      }
      for (var b in this.premis) {
        if(this.premis[b].value == data.premis_id){
          this.form.lkp_negeri_id = this.premis[b].lkp_negeri_id;
          this.form.lkp_negeri = this.premis[b].lkp_negeri;
          this.getJuruteknik(data);
        }
      }
    },

    getJuruteknik(data){
      this.premis_id = this.form.premis_id
      if(data.lkp_negeri_id !=''){
        this.$zcomm.get(this.api_service + 'lookup/juruteknik_ai/'+data.lkp_negeri_id+'/1'+'/0'+'/'+this.premis_id, this.carian_juru, {}).then(res => {
          this.juruteknik_list = res || []
        }).catch(err => console.error('Error loading juruteknik:', err));
      }
    },
    
    getJenisTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res || []
      }).catch(err => console.error('Error loading jenis ternakan:', err));
    },

    getArt(){
      this.$zcomm.get(this.api_service + 'lookup/art', {}).then(res => {
        this.lkp_art = res || []
      }).catch(err => console.error('Error loading art:', err));
    },

    tutup(){
      this.$inertia.visit(window.route('art.semakan.index'));
    },
        
    getBakaTernakan(i){
      const url = this.api_service + 'lookup/baka_ternakan/' + (i || 0);
      this.$zcomm.get(url, {}).then(res => {
        this.lkp_baka = res || []
      }).catch(err => console.error('Error loading baka:', err));
    },
  },

  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    this.title = 'Tambah Permohonan Perkhidmatan PERMANIAN BERADAS (AI)'
    this.getPremis()
    this.getJenisTernakan()
    this.getArt()
    this.getData()
    this.lkpBerahi()
  }
}
</script>

<style scoped>
.filter-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  border: 1px solid #e0e6ed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.filter-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filter-icon {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 2px solid #d1d9e6;
}

.filter-icon w-icon {
  font-size: 1.3rem;
  color: #2c7da0;
}

.filter-title {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 0.5px;
}

.filter-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-input {
  flex: 1;
}

.clear-filter-btn {
  white-space: nowrap;
}

.filter-info {
  margin-top: 8px;
}

.badge-filter {
  display: inline-flex;
  align-items: center;
  background-color: #e8f0f5;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  color: #2c7da0;
  font-weight: 500;
}

.highlight-match {
  background-color: #fff3cd !important;
}

.highlight-text {
  background-color: #ffeb3b;
  color: #333;
  font-weight: bold;
  padding: 0 2px;
  border-radius: 3px;
}

.modern-table-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background-color: #fff;
  border: 1px solid #eaeaea;
}

.table-scroll-wrapper {
  overflow-x: auto;
  max-height: 400px;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

.table-scroll-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 4px;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.table-header {
  background-color: #f8f9fa;
  padding: 16px 12px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #eaeaea;
  position: sticky;
  top: 0;
  z-index: 10;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f0f0f0;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.table-cell {
  padding: 14px 12px;
  font-size: 0.9rem;
  color: #333;
  vertical-align: middle;
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  color: #888;
  font-size: 1rem;
}

.modern-select {
  min-width: 120px;
  margin: 5px 0;
}

.header-checkbox, .row-checkbox {
  transform: scale(1.1);
}

.notice-container {
  display: flex;
  background-color: #fff3cd;
  border-left: 4px solid #ffc107;
  border-radius: 8px;
  padding: 16px;
}

.notice-icon {
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-icon-symbol {
  font-size: 1.5rem;
  color: #856404;
}

.notice-content {
  flex-grow: 1;
}

.notice-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #856404;
}

.notice-message {
  margin: 0;
  color: #856404;
}

.mt1 { margin-top: 4px; }
.mt2 { margin-top: 8px; }
.mt3 { margin-top: 16px; }
.ml1 { margin-left: 8px; }
.mr1 { margin-right: 8px; }
</style>